export default "__VITE_ASSET__Dxbjo9_u__"